
import {useState, useEffect} from 'react'
import { VscEye, VscEyeClosed  } from "react-icons/vsc";


import './Input.css'
export default function Input({value, onChange, name, label}){

    const [showPassword, setShowPassword] = useState(false)

    useEffect(()=>{
        if(!showPassword){
            
        }
    },[])
    
    return <div>
            <label className="label" for={name}>
                {label} *
            </label>
            <div className="passwordInput">
                <input  
                id={name}
                type={showPassword ? "text" : "password"}
                name={name}
                value={value}
                placeholder="Digite sua senha"
                onChange={onChange}
                required
                className="input"
                />
                <button onClick={()=>setShowPassword(!showPassword)}>
                    {showPassword
                        ? 
                        <VscEye color="#fff" size={20} />: 
                        <VscEyeClosed color="#fff" size={20} />}
                </button>
            </div>
    </div>

}